/**
 @ngdoc service
 @name mapScreeningbusinessrecordTileService
 @description
 factory used by mapTilesJsonData.js to construct tile data into tileData object
 */

(function() {
    'use strict';

    var mapScreeningbusinessrecordTileService = function(tileDataFactory) {

        var map = function(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData){
            var self = this;

            // Assigning tile factory function with parameters to variable
            var tileFactory = new tileDataFactory.constructTileData(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData);

            // Adding labels to column structured data
            tileFactory.addFieldToColumn1(tileFactory.field.newField('id'));

            tileFactory.addFieldToColumn1(tileFactory.field.newRankedInactiveField(
                'phoneNo',
                [['phoneStrike', 'phoneStrike'], ['unsubscribedFromCalls', 'unsubscribedFromCalls']]
            ));

            tileFactory.addFieldToColumn2(tileFactory.field.newAddressField('addressShort'));

            tileFactory.addFieldToColumn4(tileFactory.field.newFieldWithAdditionalInfo('businessType', 'businessTypeDescription'));
            if(rawTileData.attachedManager > 0) {
                tileFactory.addFieldToColumn4(tileFactory.field.newLinkField('attachedManager', 'attachedManagerURI'));
            }
            else{
                tileFactory.addFieldToColumn4(tileFactory.field.newField('attachedManager'));
            }


            return tileFactory.tileData;

        };

        return {
            map : map
        };
    };

    mapScreeningbusinessrecordTileService.$inject = ['tileDataFactory'];
    angular.module('app').factory('mapScreeningbusinessrecordTileService', mapScreeningbusinessrecordTileService);
}());